// De ENIGE bron van waarheid voor de headline-status van een placement-proces
// (IV1..IV6 / Aanbieding arbeidscontract).
//
// Waarom dit bestaat (eigenaarsbesluit 27 juli 2026): de oude regel in de deals-
// PATCH keek naar OVERGANGEN ("is de deal net de Closing-fase in gegaan", "is
// 'Aanbieding ontvangen van klant' NET aangevinkt"). Flank-logica vraagt voor
// elke voorwaartse overgang een even precieze terugwaartse overgang, en die was
// er niet: zodra de status eenmaal op 'Aanbieding arbeidscontract' stond was zijn
// rang (7) hoger dan elke IV-ronde, waardoor de verlagende tak
// (`curRank < hiIv || isIvStatus`) onbereikbaar werd. Een vinkje weghalen of de
// fase terugzetten haalde de status dus NOOIT meer omlaag - alleen een handmatige
// dropdown-keuze kon dat. Dat is de ratel die proces-1778481880824 op 'Aanbieding'
// liet staan terwijl het daar niet stond.
//
// Deze functie kent daarom GEEN overgangen en GEEN geheugen: ze leest alleen de
// huidige staat. Symmetrie is daarmee geen aparte regel maar een gevolg - een
// vinkje weghalen of een IV-datum wissen laat de status vanzelf zakken.
//
// Optie C (eigenaarskeuze): de status is NERGENS meer direct schrijfbaar. De
// dropdown in de UI schrijft SIGNALEN (een IV-datum, het aanbiedingsvinkje) en de
// status volgt. Elke statuswijziging laat zo een echt spoor na op het proces.

export const OFFER_ACTION = 'Aanbieding ontvangen van klant';
export const OFFER_STATUS = 'Aanbieding arbeidscontract';
export const IV_ROUNDS = [1, 2, 3, 4, 5, 6];

// Checklist-sleutels zijn `${phaseIdx}:${action}` (of, historisch, de kale actie).
export function actionTextOf(key) {
  const s = String(key);
  return s.includes(':') ? s.slice(s.indexOf(':') + 1) : s;
}

export function isOfferChecked(phaseChecklist) {
  return Object.entries(phaseChecklist?.actions || {})
    .some(([k, v]) => v && actionTextOf(k) === OFFER_ACTION);
}

// Hoogste IV-ronde met een DATUM. Een kloktijd is optioneel - zo was de regel al
// en zo blijft hij: plannen is de handeling, niet het precieze tijdstip.
export function highestIvRound(deal) {
  let hi = 0;
  for (const n of IV_ROUNDS) if (deal?.[`iv${n}Date`]) hi = n;
  return hi;
}

// De afleiding. `lastPhaseIndex` is de index van de Closing-fase (server: uit de
// phases-config; client: phases.length - 1), zodat een director die de fasen
// aanpast niet in een hardcoded getal loopt.
//
// Volgorde van winnen:
//   1. Aanbieding - het aanbiedingsvinkje staat aan OF de deal staat in Closing.
//   2. IV{hoogste ronde met datum}.
//   3. Leeg - er is nog niets gepland.
//
// signed/rejected staan bewust BUITEN deze functie: dat zijn eigen booleans op de
// deal en ze overrulen de weergave elders. Hier niet nog eens, anders zijn er weer
// twee plekken die hetzelfde beweren.
export function derivePlacementStatus(deal, lastPhaseIndex) {
  if (!deal) return '';
  const pc = deal.phaseChecklist || { phaseIndex: 0, actions: {} };
  const inClosing = Number.isFinite(lastPhaseIndex)
    && lastPhaseIndex >= 0
    && (pc.phaseIndex ?? 0) >= lastPhaseIndex;
  if (inClosing || isOfferChecked(pc)) return OFFER_STATUS;
  const hi = highestIvRound(deal);
  return hi > 0 ? `IV${hi}` : '';
}

// Welk signaal hoort bij een status die iemand in de dropdown kiest? De UI gebruikt
// dit om optie C uit te voeren: de keuze schrijft het signaal, nooit de status.
//   - 'Aanbieding arbeidscontract' -> zet het aanbiedingsvinkje.
//   - 'IV{n}'                      -> vraagt een datum voor ronde n.
// Retourneert null voor een status die geen signaal kent (dan hoort de UI niets te
// doen in plaats van iets te verzinnen).
export function signalForStatus(status) {
  const s = String(status || '');
  if (s === OFFER_STATUS) return { kind: 'offer', action: OFFER_ACTION };
  const m = /^IV([1-6])$/.exec(s);
  if (m) return { kind: 'ivDate', round: Number(m[1]), field: `iv${m[1]}Date` };
  return null;
}
